import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';

import ListItemDecorator from '@mui/joy/ListItemDecorator';

import { getIcon } from 'utils/misc';

const DefaultProjectIcon = getIcon('ChecklistRtlTwoTone');
const DefaultCollabIcon = getIcon('Group');
// const DefaultPrivacyIcon = getIcon('AdminPanelSettings');
const DefaultClickAroundIcon = getIcon('Mouse');
const RequestIcon = getIcon('ListAlt');
// import NewIcon from '@mui/icons-material/Add';



export default function ProjectCopy() {
    return (
        <Sheet sx={{ m: 1 }}>

            <List>

                <ListItem>
                    <ListItemDecorator>
                        <DefaultProjectIcon />
                    </ListItemDecorator>
                    <Typography level="body-sm">
                        This is a project. This is where you get things done.
                    </Typography>
                </ListItem>

                <ListItem>
                    <ListItemDecorator>
                        <DefaultCollabIcon />
                    </ListItemDecorator>
                    <Typography level="body-sm">
                        A project can contain many collaborations with many different assistants.
                    </Typography>
                </ListItem>

                <ListItem>
                    <ListItemDecorator>
                        <RequestIcon />
                    </ListItemDecorator>
                    <Typography level="body-sm">
                        A project can contain standard Fancy Hands requests.
                    </Typography>
                </ListItem>

                {/*
                    <ListItem>
                        <ListItemDecorator>
                            <DefaultPrivacyIcon />
                        </ListItemDecorator>
                        <Typography level="body-sm">
                            Privacy is built in with the ability to stay anonymous.
                        </Typography>
                            </ListItem>
        */}
                <ListItem>
                    <ListItemDecorator>
                        <DefaultClickAroundIcon />
                    </ListItemDecorator>
                    <Typography level="body-sm">
                        Click around and find out. You're safe here.
                    </Typography>
                </ListItem>
            </List>
        </Sheet>
    );
}
